<template>
  <a-modal
    title="订单详情"
    :dialogStyle="{ minWidth: '1200px' }"
    :bodyStyle="{ maxHeight: '800px', overflow: 'auto' }"
    :visible="visible"
    @cancel="$emit('update:visible', false)"
  >
    <template #footer>
      <a-button @click="$emit('update:visible', false)">取消</a-button>
    </template>
    <a-descriptions :column="3" title="订单信息">
      <a-descriptions-item v-for="v in orderDesc" :key="v.key" :label="v.key" :span="1">
        {{ v.value }}
      </a-descriptions-item>
    </a-descriptions>
    <a-divider/>
    <h3 style="font-weight: 550;margin-bottom: 20px">商品信息</h3>
    <a-table
      ref="table"
      size="default"
      :columns="columns"
      :dataSource="goodsList"
      :pagination="false"
    ></a-table>
  </a-modal>
</template>
<script>
import {loadOrderDetail} from "@/api/account";
import getOrderDescMixin from "@/mixins/getOrderDescMixin";

export default {
  mixins: [getOrderDescMixin],
  props: {
    visible: {
      type: Boolean,
      require: true
    },
    orderId: {
      type: String,
      require: true
    }
  },
  data () {
    return {
      columns: [
        {
          title: '商品名称',
          dataIndex: 'itemName'
        },
        {
          title: '品牌',
          dataIndex: 'brandName'
        },
        {
          title: '规格',
          dataIndex: 'specs',
          customRender: (text, record, index) => `${record.specs}${record.specsUnit}`
        },
        {
          title: '数量',
          dataIndex: 'quantity'
        },
        {
          title: '积分',
          dataIndex: 'points'
        },
        {
          title: '小计',
          customRender: (text, record, index) => `${(record.points * record.quantity).toFixed(2)}`
        }
      ],
      orderInfo: null
    }
  },
  watch: {
    visible (val) {
      if (val) {
        loadOrderDetail(this.orderId).then(res => {
          this.orderInfo = res.data
        })
      } else {
        this.orderInfo = null
      }
    }
  },
  computed: {
    orderDesc () {
      return this.getOrderDesc(this.orderInfo)
    },
    goodsList () {
      if (!this.orderInfo) return []
      return this.orderInfo.pointsOrderItems
    }
  }
}
</script>
